import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { exportTableToCsv } from "../../utils/exportTableCsv";

export default function VehicleSearchTable({
    heading,
    vehicleSearchUsers,
    loading,
    history,
    search,
    setSearch,
}) {
    const [first, setFirst] = React.useState(0);
    const [rows, setRows] = React.useState(50);

    const formatDate = (date) => {
        if (!date) return "-";

        return date.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    const actions = (rowData) => (
        <div className="flex justify-content-around">
            <i
                className="pi pi-eye cursor-pointer text-dark"
                onClick={() => history(`/vehicle-search/view/${rowData._id}`)}
            ></i>
        </div>
    );

    React.useEffect(() => {
        setFirst(0);
    }, [search, vehicleSearchUsers.length]);

    const exportAll = () => {
        exportTableToCsv("vehicle-search.csv", vehicleSearchUsers, [
            { header: "Name", value: (user) => user.firstName || "-" },
            { header: "Vehicle Number", value: (user) => user.vehicleNumber || "-" },
            { header: "Mobile", value: (user) => user.mobile || "-" },
            { header: "Vehicle Brand", value: (user) => user.vehicleBrand?.name || "-" },
            { header: "Vehicle Model", value: (user) => user.vehicleModel?.name || "-" },
            { header: "Registered RTO Address", value: (user) => user.permanentAddress || "-" },
            { header: "Search Date", value: (user) => (user.time ? formatDate(user.time) : "-") },
        ]);
    };

    return (
        <div className="col-12">
            <div className="card">
                <div className="flex justify-content-between mb-4">
                    <h5>{heading}</h5>
                    <div className="flex align-items-center">
                        <div className="p-input-icon-left mx-2">
                            <i className="pi pi-search" />
                            <InputText
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                placeholder="Search"
                            />
                        </div>
                        <Button
                            label="Export CSV"
                            icon="pi pi-download"
                            onClick={exportAll}
                            disabled={!vehicleSearchUsers.length}
                            severity="success"
                        />
                    </div>
                </div>
                <DataTable
                    paginator
                    value={vehicleSearchUsers}
                    first={first}
                    rows={rows}
                    onPage={(event) => {
                        setFirst(event.first);
                        setRows(event.rows);
                    }}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    sortMode="multiple"
                    loading={loading}
                    emptyMessage="No vehicle search user found."
                    className="custom-datatable-header"
                    showGridlines
                >
                    <Column field="firstName" header="Name" sortable></Column>
                    <Column field="vehicleNumber" header="Vehicle Number" sortable></Column>
                    <Column field="mobile" header="Mobile" sortable></Column>
                    <Column
                        body={(rowData) => rowData.vehicleBrand?.name || "-"}
                        header="Vehicle Brand"
                        sortable
                        sortField="vehicleBrand.name"
                    ></Column>
                    <Column
                        body={(rowData) => rowData.vehicleModel?.name || "-"}
                        header="Vehicle Model"
                        sortable
                        sortField="vehicleModel.name"
                    ></Column>
                    <Column
                        body={(rowData) => rowData.permanentAddress || "-"}
                        header="Registered RTO Address"
                    ></Column>
                    <Column
                        header="Search Date"
                        field="time"
                        body={(rowData) => formatDate(rowData.time)}
                        style={{ width: "150px" }}
                        sortable
                    />
                    <Column body={actions} style={{ width: "80px" }} header="Action"></Column>
                </DataTable>
            </div>
        </div>
    );
}
